var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMediaGroupInformation = function SvgMediaGroupInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11V1Q0 .588.294.294A.96.96 0 0 1 1 0h3.5q.412 0 .706.294A.96.96 0 0 1 5.5 1v10h-1v-1H1v1zm2-5 1.75-1L2 4zM6.5 11V3.727a.7.7 0 0 1 .214-.513A.7.7 0 0 1 7.227 3h2.546a.7.7 0 0 1 .513.214.7.7 0 0 1 .214.513V11h-.727v-.727H7.227V11zm1.455-3.636 1.272-.728-1.272-.727z"
  })));
};
export default SvgMediaGroupInformation;